/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Insurance/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddAction from './AddAction/index'
import AssignedInsurance from './AssignedInsurance/index'
import React from 'react'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaCardHeader from 'DesignSystem/TysiaCard/TysiaCardHeader/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import Tysiav2Insurance from 'DesignSystem/Svgs/Tysiav2Insurance/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Insurance({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance"
  
}) {
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 size="xlarge"
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<React.Fragment>
<TysiaCardHeader
{...childProps}
  viewPath={`${viewPath}/TysiaCardHeader`}
 paddingTop={dtSpaceLs}
 paddingBottom={dtSpaceLs}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 borderBottomColor={dtColorsNeutral200}
 borderBottomWidth={1}
>
{childProps => (
<div
  data-testid="Insurance.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Insurance.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-2s0C3T': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2Insurance
  viewPath={`${viewPath}/Tysiav2Insurance`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 text="Insurances"
/>
</div>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
)}
</TysiaCardHeader>
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 overflowX="visible"
 overflowY="visible"
 paddingBottom={0}
 paddingLeft={0}
 paddingRight={0}
 paddingTop={0}
 flexDirection="column"
>
{childProps => (
<AssignedInsurance
{...childProps}
  viewPath={`${viewPath}/AssignedInsurance`}
/>
)}
</TysiaCardContent>
</React.Fragment>
)}
</TysiaCard>
{children}
</React.Fragment>)
}